import Splide from '@splidejs/splide';

export function mediaContentSlider() {
    const $sliders = document.querySelectorAll('.media-content__splide');

    if ( !$sliders.length ) return;

    $sliders.forEach($slider => {
        var splide = new Splide($slider, {
            type: 'loop',
            perPage: 1,
            gap: '1rem',
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 3000,
            pauseOnHover: true,
            pauseOnFocus: true,
        });
        splide.mount();
    });
}